const shopperIdRegex = /^((\d+)|([a-z0-9]{3}))$/i;
const shopperSets = new WeakMap();

function toLowerCaseSafe(unknownTypeValue) {
  const maybeString = unknownTypeValue && unknownTypeValue.toString();
  return maybeString && maybeString.toLowerCase();
}

module.exports = {
  validate(rule) {
    return (rule.shopperIds instanceof Array) && rule.shopperIds.every(id => shopperIdRegex.test(id));
  },

  test({ params, rule }) {
    let shopperSet = shopperSets.get(rule);
    if (!shopperSet) {
      shopperSet = new Set(rule.shopperIds.map(toLowerCaseSafe));
      shopperSets.set(rule, shopperSet);
    }

    return shopperSet.has(toLowerCaseSafe(params && params.shopperId));
  }
};
